export default [
    {
        path: '/checkout',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "checkout" */ '../views/Checkout.vue'),
        meta: {
            requiresAuth: true,
            showNavbarCart: false,
            showBackButton: true,
        }
    },
    {
        path: '/checkout/success',
        name: 'checkout-success',
        component: () => import(/* webpackChunkName: "checkout" */ '../views/CheckoutSuccess.vue'),
        meta: {
            requiresAuth: true,
            showNavbarCart: false,
            showBackButton: true,
        }
    },
    {
        path: '/checkout/complete',
        name: 'checkout-complete',
        component: () => import(/* webpackChunkName: "checkout" */ '../views/CheckoutComplete.vue'),
        meta: {
            requiresAuth: true,
            showNavbarCart: false,
            showBackButton: true,
        }
    },
]

